import axios from "axios";

export const callApi = async (endpoint, method = "GET", data, params, headers, isProfileUrl) => {
  try {
    const baseURL = isProfileUrl ? process.env.REACT_APP_BASE_URL_PROFILE : process.env.REACT_APP_BASE_URL;
    const response = await axios({
      url: `${baseURL}${endpoint}`,
      method,
      data,
      params,
      headers,
    });
    return response.data;
  } catch (error) {
    console.log("❌ API Error:", error);
    const statusCode = error.response?.status || 500;
    throw {
      message: error.response?.data?.message || "Server Error",
      statusCode,
    };
  }
};
